<template>
  <div class="" id="srcoll">
    <!-- 固定放在最前面的“是否是会员”部分 -->
    <!-- <dl class="list">
      <dt style="margin-bottom: 0.27rem;margin-top: 0.4rem;">
        是否是会员(仅用于老会员号绑定账号使用)
      </dt>
      <dd class="anniu">
        <van-field class="input-item">
          <template #input>
            <van-radio-group v-model="isMember">
              <template v-for="itemV in fieldDictionary('ORAL_REPORT')">
                <van-radio :key="itemV.seq" :name="itemV.value">{{
                  itemV.name
                }}</van-radio>
              </template>
            </van-radio-group>
          </template>
        </van-field>
      </dd>

      <dt v-if="isMember == 1" style="margin-bottom: 0.27rem;margin-top: 0.4rem;">
        会员号<sup>*</sup>
        <span style="margin-left: 0.6rem; font-size: 12px;color: #686868" @click="goMemberSearch()">不记得? 去查询</span>
      </dt>
      <dd v-if="isMember == 1">
        <template>
          <van-field class="input-item" v-model="ruleForm.memberNo"
            show-word-limit placeholder="请输入会员号" />
        </template>
      </dd>
    </dl> -->
    <div class="">
      <template v-for="item in settingDetail">
        <template v-if="item.display && item.fieldCaption != null">
          <dl class="list" :key="item.id">
            <dt :class="{ fieldLabelRequired: !item.nullable }">
              {{ item.fieldCaption }} <sup v-if="item.nullable==0">*</sup>
            </dt>
            <template v-if="item.editorType == 1&&item.field=='mobile'">
              <!-- 单行文本框 手机号 -->
              <dd>
                <van-field class="input-item" :disabled="(disabled||infoDisabled)&&codeStatus"
                  v-model="ruleForm[item.field]" :maxlength="item.fieldLength" show-word-limit
                  :placeholder="'请输入' + item.fieldCaption" :readonly="item.disabled ? item.disabled : false"
                  :rules="rules(item)" />
              </dd>
              <!-- <dt style="margin-bottom: 0.27rem;margin-top: 0.4rem;">
                是否是会员(仅用于老会员号绑定账号使用)
              </dt>
              <dd class="anniu">
                <van-field class="input-item">
                  <template #input>
                    <van-radio-group v-model="isMember">
                      <template v-for="itemV in fieldDictionary('ORAL_REPORT')">
                        <van-radio :key="itemV.seq" :name="itemV.value">{{
                          itemV.name
                          }}</van-radio>
                      </template>
                    </van-radio-group>
                  </template>
                </van-field>
              </dd>

              <dt v-if="isMember == 1" style="margin-bottom: 0.27rem;margin-top: 0.4rem;">
                会员号<sup>*</sup>
                 <span style="margin-left: 0.6rem; font-size: 12px;color: #686868" @click="goMemberSearch()">不记得? 去查询</span>
              </dt>
              
              <dd v-if="isMember == 1">
                <template>
                  <van-field class="input-item" v-model="ruleForm.memberNo"
                    show-word-limit placeholder="请输入会员号"
                  />
                </template>
              </dd> -->

              <dt v-if="!loginStatus" style="margin-bottom: 0.27rem;margin-top: 0.4rem;">
                图形验证码 <sup>*</sup>
              </dt>
              <dd>
                <van-field v-if="!loginStatus" :disabled="(disabled||infoDisabled)&&codeStatus" class="input-item"
                  v-model="captcha" placeholder="请输入图片验证码" style="display: flex;align-items: center;">
                  <div slot="button" @click="changeCode()">
                    <img v-if="captchaImage" :src="captchaImage" class="chaImage" />
                  </div>
                </van-field>
              </dd>
              <dt v-if="!loginStatus" style="margin-bottom: 0.27rem;margin-top: 0.4rem;">
                验证码 <sup>*</sup>
              </dt>
              <dd>
                <van-field v-if="!loginStatus" :disabled="(disabled||infoDisabled)&&codeStatus" class="input-item"
                  @input="checkCode()" v-model="ruleForm.messageCode" placeholder="请输入验证码">
                  <van-button :disabled="disabledCode" v-if="!codeStatus" slot="button" plain size="small"
                    @click="getCode">
                    <template v-if="!isSpend">
                      <div class="button-3 text-70">获取验证码</div>
                    </template>
                    <template v-else>
                      <div class="button-6 text-71">重新发送( {{ time }} )</div>
                    </template>
                  </van-button>
                  <van-button v-if="codeStatus" slot="button" plain size="small">
                    <template>
                      <div class="button-3 text-70">验证通过</div>
                    </template>
                  </van-button>
                </van-field>
              </dd>

            </template>
            <!-- 单行文本框 -->
            <dd v-if="item.editorType == 1&&item.field!='mobile'">
              <!-- 姓名 -->
              <template v-if="item.field=='name'">
                <van-field class="input-item" :disabled="disabled" :rules="rules(item)" v-model="ruleForm[item.field]"
                  :maxlength="item.fieldLength" show-word-limit :placeholder="'请输入' + item.fieldCaption"
                  :readonly="item.disabled ? item.disabled : false" />
              </template>

              <template v-if="item.field!='name'">
                <van-field class="input-item" :disabled="disabled" :rules="rules(item)" v-model="ruleForm[item.field]"
                  :maxlength="item.fieldLength" show-word-limit :placeholder="'请输入' + item.fieldCaption"
                  :readonly="item.disabled ? item.disabled : false" />
              </template>

            </dd>
            <!-- 多行文本 -->
            <dd v-if="item.editorType == 7">
              <van-field class="input-item" :rules="rules(item)" :disabled="disabled" v-model="ruleForm[item.field]"
                :maxlength="item.fieldLength" show-word-limit type="textarea"
                :placeholder="'请输入' + item.fieldCaption" />
            </dd>
            <!-- 下拉框 -->
            <dd v-if="item.editorType == 4">
              <van-field class="input-item" :disabled="disabled" :rules="rules(item)" :value="getDisplayValue(ruleForm[item.field], item)
              ? getDisplayValue(ruleForm[item.field], item)
              : ''
          " :maxlength="item.fieldLength" :placeholder="'请选择' + item.fieldCaption" readonly
                @click="showPicker(item, undefined) ">
              </van-field>

            </dd>
            <!-- 多选下拉框 -->
            <dd v-if="item.editorType == 11">
              <van-field class="input-item" :disabled="disabled" :rules="rules(item)" v-model="ruleForm[item.field]"
                :maxlength="item.fieldLength" :placeholder="'请选择' + item.fieldCaption" readonly
                @click="showConcernBranchPicker(item, ruleForm[item.field])" is-link>
              </van-field>
            </dd>
            <!-- 单选 -->
            <dd v-if="item.editorType == 5" class="anniu">
              <van-field class="input-item" :rules="rules(item)">
                <template #input>
                  <van-radio-group v-model="ruleForm[item.field]" :disabled="disabled || (item.field == 'isStudent' && 
              ruleForm.isPay && ruleForm.isPay == 2)" direction="horizontal">
                    <template v-for="itemV in fieldDictionary(item.dictionaryId)">
                      <van-radio :key="itemV.seq" :name="itemV.value">{{
                        itemV.name
                        }}</van-radio>
                    </template>
                  </van-radio-group>
                </template>
              </van-field>
            </dd>
            <!--复选框 -->
            <dd v-if="item.editorType == 14" class="anniu">
              <van-field class="input-item" :rules="rules(item)">
                <template #input>
                  <van-checkbox-group v-model="ruleForm[item.field]" :disabled="disabled" direction="horizontal">
                    <template v-for="itemV in fieldDictionary(item.dictionaryId)">
                      <van-checkbox :key="itemV.seq" :name="itemV.value">{{
                        itemV.name
                        }}</van-checkbox>
                    </template>
                  </van-checkbox-group>
                </template>
              </van-field>
            </dd>

            <!-- 日期选择框 3 时间 13日期-->
            <dd v-if="item.editorType == 3||item.editorType == 13">
              <van-field class="input-item" :disabled="disabled" :rules="rules(item)" v-model="ruleForm[item.field]"
                :maxlength="item.fieldLength" :placeholder="'请选择' + item.fieldCaption" readonly
                @click="showDatePicker(undefined, item)" is-link>
              </van-field>
            </dd>
            <!-- 文件类型 -->
            <dd v-if="item.editorType == 2">
              <el-upload style="width: 100%;" :action="photoIdUrl" :accept="item.limitType?item.limitType:'*'"
                :on-success="(res, file, fileList)=>{return handleSuccessSeal(res,file,fileList,item)}"
                :before-upload="(file)=>{return beforeAvatarUpload(file,item)}"
                :class="{ disUoloadSty: noneBtnDealImg }" :on-remove="(file)=>{return handleRemoveImgSeal(file,item)}"
                :on-exceed=" (file)=>{return handExceed(file,item)}" :limit="item.maxNum" :file-list="item.fileList"
                  :headers="getUploadHeaders()">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </dd>

            <!--  <div class="van-cell__title" style="position: relative;">
                <p>{{field.fieldCaption}}</p>
              </div>
              <template>
                <div style="padding:30px 20px 10px 20px">
                  <van-uploader v-model="item.fileList" accept="image/*" :after-read="beforeUpload" @delete="delFile"
                    :max-count="1">
                  </van-uploader>
                </div>
             

            </template> -->
            <!-- 地区选择框 -->
            <dd v-if="item.editorType == 10">
              <!-- 地区选择框 -->
              <van-field class="input-item" :placeholder="'请选择'+item.fieldCaption"
                :value="getShengName(ruleForm[item.field.split(',')[0]]) + getCityName(ruleForm[item.field.split(',')[1]])"
                is-link :required="item.nullable==0" @click="showAddressPicker(item, undefined)" readonly />
            </dd>

          </dl>
        </template>
      </template>
    </div>
    <!-- 选择弹窗 -->

    <van-popup v-model="selectModel" position="bottom">
      <div v-if="dateField">
        <!-- <van-datetime-picker v-if="dateField.editorType==3" :min-date="minDate" :value="dateField.value" type="datetime"
          @cancel="onCancel" @confirm="onConfirmDate2" /> -->
        <van-datetime-picker :min-date="minDate" :value="dateField.value" type="date" @cancel="onCancel"
          @confirm="onConfirmDate" />
      </div>
      <van-picker v-else-if="selectKey=='province'" show-toolbar ref="picker" value-key="name" :columns="columns"
        @change="onChange" @cancel="onCancel" @confirm="onConfirm" />
      <van-picker v-else show-toolbar ref="picker" value-key="name" :columns="columns" @change="onChange"
        @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>

    <!-- 下拉多选弹窗 -->
    <van-popup v-model="selectBranchModel" position="bottom" :style="{ 'min-height': '20%' }" class="inputSelect">
      <div class="selectDiv">
        <div class="btn_left" @click="selectCancel()">取消</div>
        <div class="btn_true" @click="selectChecked()">确定</div>
      </div>
      <van-checkbox-group v-model="selection" direction="horizontal">
        <van-checkbox style=" margin-left: 0.32rem;
          min-width: 43%;
          height: 0.8rem;" :name="item.value" v-for="(item, index) in columns" :key="index" :value="item.seq">{{
          item.value }}</van-checkbox>
      </van-checkbox-group>
    </van-popup>
  </div>
</template>
<script type="text/javascript">
  import { mapMutations, mapGetters, mapActions } from "vuex"
  import { uploadURL, uploadFile, delFile } from "@/api/upload";
  import {
    Uploader,
    Toast,
    Field,
    Button,
    DatetimePicker,
    Popup,
    Picker,
    Cell,
    CellGroup,
    Divider,
    RadioGroup,
    Radio,
    Area,
    Icon,
    Form,
    Checkbox,
    CheckboxGroup
  } from "vant"
  import { getDictionary, getDivisionData, checkRegister } from "@/api/dictionary"
  import { getMobileLoginCode, checkRegisterCode, getCaptchaImage } from "@/api/login"
  import { getStore } from "@/utils/sessionStorage"
  import CryptoJS from 'crypto-js';
  export default {
    props: {
      disabled: Boolean,
      infoDisabled: Boolean,
      form: Object,
      unitDetail: Array,
      modifyDetail: Boolean,
      loginStatus: Boolean,
      ruleForm: {
        type: Object,
        default: () => { },
      },
      // allAddress: {
      //   type: Array,
      //   default: () => [],
      // },
      index: {
        type: Number,
      },
    },
    data() {
      return {
        isMember: 2,
        captchaImage: '',
        captcha: '',
        photoIdUrl: uploadURL,
        nameDisabled: false,
        sealList: [],
        uploadIds: [],
        noneBtnDealImg: false,
        dialogSeal: false,
        settingDetail: {},
        // ruleForm: {},
        pickerField: undefined, // 弹窗选择对应的字段
        dateField: undefined, // 弹窗日期选择的字段,
        selectModel: false,
        selectModelFc: false,
        columns: [],
        discountPrice: "",
        originalPrice: "",
        allDictionary: [],
        orderIsPay: {},
        ruleFormVal: "",
        key: "name", //选择弹窗显示对应的参数名
        codeStatus: false,
        isSpend: false,
        time: '',
        disabledCode: false,
        selectBranchModel: false,
        selection: '',
        allAddress: [],
        selectKey: ""
      }
    },
    components: {
      [Uploader.name]: Uploader,
      [Toast.name]: Toast,
      [Field.name]: Field,
      [Button.name]: Button,
      [DatetimePicker.name]: DatetimePicker,
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [CellGroup.name]: CellGroup,
      [Cell.name]: Cell,
      [Divider.name]: Divider,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [Area.name]: Area,
      [Icon.name]: Icon,
      [Form.name]: Form,
      [Checkbox.name]: Checkbox,
      [CheckboxGroup.name]: CheckboxGroup,
    },
    watch: {
      unitDetail(newVal) {
        this.settingDetail = newVal
        this.registerNumDisabled(this.settingDetail)
      },
    },
    methods: {
      ...mapMutations(["setAddrList"]),
      ...mapActions(["securityCheck","getInvoiceList"]),
      changeCode() {
        this.getCaptchaImageFunction()
      },
      getCaptchaImageFunction() {
        let captchaUuid = "";
        if (sessionStorage.getItem("captchaUuid")) {
          captchaUuid = sessionStorage.getItem("captchaUuid");
        } else {
          //生成captchaUuid
          let times = new Date().getTime();
          let numNo = Number(Math.random().toString().substr(2));
          captchaUuid = (times + numNo).toString(12);
          sessionStorage.setItem("captchaUuid", captchaUuid);
        }
        getCaptchaImage({ captchaUuid: captchaUuid }).then(res => {
          if (res.success) {
            this.$set(this, "captchaImage", res.result)
          } else {
            this.$message.error(res.message || "验证码生成失败");
          }
        })
      },
      getDisplayValue(value, field) {
        var optionsData = this.fieldDictionary(field.dictionaryId)
        var currentItem = optionsData.find((item) => item.value === value)
        return currentItem ? currentItem.name : ""
      },
      // 判断名字是否禁用
      isnameDisabled(val) {
        this.nameDisabled = val
      },
      goMemberSearch(){
        this.$router.push({ name: 'memberSearch', query: { meetingId: this.meetingId } });
      },
      // 验证码
      getCode() {
        this.disabledCode = true
        let mobile = this.ruleForm.mobile
        // !this.userParams.code ||
        if (
          !this.ruleForm.mobile
        ) {
          this.disabledCode = false
          Toast.fail("请输入手机号！")
          return
        }
         if (
          !this.ruleForm.name
        ) {
          this.disabledCode = false
          Toast.fail("请输入报名姓名！")
          return
        }

        if (this.isSpend) {
          this.disabledCode = false
          return
        }
        if (!this.$regexp.mobile(mobile)) {
          Toast.fail("请输入正确的手机号！")
          this.disabledCode = false
          return false
        }

        if (this.isMember == 1 && !this.ruleForm.memberNo) {
            Toast.fail("请输入会员号！")
            this.disabledCode = false
            return false
        }

        if (!this.captcha) {
          Toast("请输入图形验证码");
          this.disabledCode = false
          return false;
        }
        //生成签名
        let timestamp = new Date().getTime();
        let data = "appSecretKey=captcha_codes&mobile=" + mobile + "&timestamp=" + timestamp;
        let sign = this.$md5(data);
        getMobileLoginCode({
          mobile: mobile, captchaUuid: sessionStorage.getItem("captchaUuid"),
          sign: sign, timestamp: timestamp, captcha: this.captcha
        }).then((res) => {
          if (res.success) {
            this.isSpend = true
            this.time = 30
            this.count()
          } else {
            Toast.fail(res.message)
            this.isSpend = false
            this.disabledCode = false
          }
        }).catch(error => {
          this.disabledCode = false
        })
      },
      count() {
        --this.time
        if (this.time > 0) {
          setTimeout(() => {
            this.count()
          }, 1000)
        } else {
          this.isSpend = false
          this.disabledCode = false

        }
      },
      checkCode() {
        if (
          this.ruleForm.messageCode &&
          this.ruleForm.messageCode.length == 4
        ) {
          let userParams = {}
          if (sessionStorage.getItem("openid")) {
            userParams.openid = sessionStorage.getItem("openid")
          }
          userParams.userType = 1
          const SECRET_KEY = CryptoJS.enc.Utf8.parse("5684825541395751");
          const SECRET_IV = CryptoJS.enc.Utf8.parse("8319849165191473");
          // 手机号
          let srcsMobile = CryptoJS.enc.Utf8.parse(this.ruleForm.mobile);
          let encryptedMobile = CryptoJS.AES.encrypt(srcsMobile, SECRET_KEY, {
            iv: SECRET_IV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
          })
          let mobile1 = CryptoJS.enc.Base64.stringify(encryptedMobile.ciphertext);
          userParams.mobile = mobile1;
          userParams.messageCode = this.ruleForm.messageCode
          userParams.pic = this.ruleForm.name
          if (this.isMember == 1) {
            userParams.memberNo = this.ruleForm.memberNo;
          }
          checkRegisterCode(userParams).then((res) => {
            if (res.success) {
              this.submit(res.result.user.mobile)
              window.localStorage.setItem(
                "userInfo",
                JSON.stringify(res.result.member)
              )
              this.memberId = res.result.member.id
              sessionStorage.setItem("memberId", res.result.member.id)
              this.getInvoiceList();
              this.$emit('setUserInfo', 'checkCode')
            } else {
              Toast.fail("验证码错误")
            }
          })
        }
      },
      submit(mobile) {
        var params = {
          device: 'mobile',
          username: mobile,
          password: mobile,
          grant_type: "sms",
          scope: "server",
          client_id: "mms_meeting",
          client_secret: 123456,
          mobile: mobile,
          code: this.ruleForm.messageCode,

        };
        this.securityCheck(params)
          .then((res) => {
            console.log('res', res)
            checkRegister({ meetingId: this.meetingId, memberId: this.memberId }).then(response => {
              if (response.success) {
                this.codeStatus = true
              } else {
                Toast.fail(response.message)
                if (response.message == '您所输入的参会人姓名和手机号已注册！') {
                  this.$router.push('SignUpmeetingCenter')
                }
              }
            })

          })
          .catch((res) => {
            Toast.fail(res.error_description || "验证码错误")
          })
      },
      registerNumDisabled(item) {
        if (this.orderIsPay) {
          if (
            this.orderIsPay.orderStatus == 4 ||
            this.orderIsPay.orderStatus == 5
          ) {
            item.forEach((element) => {
              if (element.field == "registerNum") {
                element.disabled = true
              }
            })
          }
        }
      },
      onConfirmDate2(time) {
        this.dateField.value = time
        //this.formData[this.dateField.field] = time;
        this.ruleForm[this.dateField.field] = this.dateFormatString2(time)
        this.selectModel = false
      },
      onConfirmDate(time) {
        this.dateField.value = time
        //this.formData[this.dateField.field] = time;
        this.ruleForm[this.dateField.field] = this.dateFormatString(time)
        this.selectModel = false
      },
      onConfirmFc(value) {
        this.ruleFormVal = value.name
        this.selectModelFc = false
        this.placeId = value.id
      },
      dateFormatString(value) {
        console.log(value)
        if (!value) {
          return ""
        }
        let date = new Date(value)
        let m = date.getMonth() + 1
        let d = date.getDate()
        if (m >= 1 && m <= 9) {
          m = "0" + m
        }
        if (d >= 0 && d <= 9) {
          d = "0" + d
        }
        return date.getFullYear() + "-" + m + "-" + d
      },
      dateFormatString2(value) {
        if (!value) {
          return ""
        }
        let date = new Date(value)
        let y = date.getFullYear()
        let m = (date.getMonth() + 1).toString().padStart(2, '0');
        let d = date.getDate().toString().padStart(2, '0');
        let h = date.getHours().toString().padStart(2, '0');
        let min = date.getMinutes().toString().padStart(2, '0');
        let s = date.getSeconds().toString().padStart(2, '0');
        return `${y}-${m}-${d}  ${h}:${min}:${s}`;
      },
      onCancelFc() {
        this.selectModelFc = false
      },
      getAddressValue(data, field) {
        console.log(data)
        field.fields = field.field.split(",")
        let name = "请选择省份"
        if (data[field.fields[0]]) {
          name = this.getShengName(Number(data[field.fields[0]]))
        }
        if (data[field.fields[1]]) {
          name = name + this.getCityName(Number(data[field.fields[1]]))
        }
        return name
      },
      getShengName(value) {
        console.log(this.sheng, value)
        let obj = this.sheng.find((item) => item.value == value)
        if (obj) {
          return obj.name
        } else {
          return ""
        }
      },
      getCityName(value) {
        let obj = this.allAddress.find((item) => item.value == value)
        if (obj) {
          return obj.name
        } else {
          return ""
        }
      },
      showDatePicker(pickerField, dateField) {
        if (this.disabled) {
          return
        }
        this.pickerField = pickerField
        this.dateField = dateField
        this.selectModel = true
      },
      showAddressPicker(pickerField, dateField) {
        this.pickerField = pickerField;
        this.columns = [
          {
            values: this.sheng,
            className: "column1",
          },
          {
            values: this.shi1,
            className: "column2",
          },
        ];
        this.selectKey = "province";
        this.selectModel = true;
      },
      getDisplayValue(value, field) {
        var optionsData = this.fieldDictionary(field.dictionaryId)
        var currentItem = optionsData.find((item) => item.value === value)
        return currentItem ? currentItem.name : ""
      },
      onChange(picker, values, index) {
        if (this.selectKey === "title") {
          picker.setColumnValues(1, values[0].children)
        } else if (this.selectKey === "jg" || this.selectKey === "province") {
          let city = this.allAddress.filter((item) => {
            return item.parentId === values[0].id
          })
          if (index === 0) {
            picker.setColumnValues(1, city)
          }
        }
      },
      showPicker(pickerField, dateField) {
        if (this.disabled) {
          return
        }
        this.dateField = false
        console.log(pickerField)
        this.pickerField = pickerField
        this.columns = this.fieldDictionary(pickerField.dictionaryId)
        this.selectModel = true
        this.selectKey = ""
      },
      onCancel() {
        this.selectModel = false
      },
      onConfirm(item) {
        this.selectModel = false
        var fieldVal

        if (this.selectKey === "province") {
          this.ruleForm.province = item[0].value
          this.ruleForm.city = item[1] ? item[1].value : ""
          console.log(this.ruleForm)
        } else {
          this.ruleForm[this.pickerField.field] = fieldVal = item.value
        }

        this.pickerField.value = fieldVal
        this.pickerField.displayValue = item.name
        this.pickerField = undefined
        this.selectKey = undefined
      },

      fieldDictionary(code) {
        return this.allDictionary.filter((item) => item.dictionaryId == code)
      },
      validateForm() {
        let errFields = []
        let _this = this
        this.settingDetail
          .sort((a, b) => a.seq - b.seq)
          .forEach(function (item) {
            if (item.nullable == true || !item.field) {
              return
            } else if (item.editorType == 10) {
              if (!_this.ruleForm[item.field] || !_this.ruleForm[item.field][0]) {
                let fields = item.field.split(",")
                if (_this.ruleForm[fields[0]]) {
                  return false
                }
                if (_this.ruleForm[fields[1]]) {
                  return false
                }
                errFields.push(item)
                return false
              }
            } else if (!_this.ruleForm[item.field]) {
              errFields.push(item)
              return false
            }

          })
        let errField = errFields && errFields[0]
        if (errField) {
          if (errField.editorType == 6 || errField.editorType == 2) {
            Toast.fail("请上传" + errField.fieldCaption)
          } else {
            console.log(errField)
            if (errField.editorType != 5) {
              // _this.$refs[errField.field][0].focus();
            }
            Toast.fail(errField.fieldCaption + "不能为空")
          }
          return false
        }
        return true
      },
      rules(field) {
        if (!field.nullable) {
          return [{
            required: true,
            message: "请输入" + field.fieldCaption,
          }]
        } else {
          return []
        }

      },
      fieldDictionary(code) {
        return this.allDictionary.filter(item => item.dictCode == code);
      },
      // 下拉多选
      showConcernBranchPicker(pickerField, dateField) {
        this.selectBranchModel = true;
        this.columns = pickerField.meetingDictionaryList
        let arr = dateField ? ("" + dateField).split(",").map((i) => i) : [];
        this.selection = arr;
        this.pickerField = pickerField;
      },
      selectChecked() {
        this.ruleForm[this.pickerField.field] = this.selection;
        let a = this.selection.join(",");
        this.ruleForm[this.pickerField.field] = a;
        this.selectBranchModel = false;
      },
      selectCancel() {
        this.selectBranchModel = false;
      },
      handleRemoveImgSeal(file, field) {
        // registerFileDelete({ id: file.id }).then((res) => {
        //   if (res.success) {
        //     this.sealList = []
        //     let newObject = ""
        //     this.$emit("changeData", newObject)
        //   }
        // })
        for (let i = 0; i < this.ruleForm[field.field].length; i++) {
          if (this.ruleForm[field.field][i].includes(file.name)) {
            this.ruleForm[field.field].splice(i, 1)
          }
        }
        console.log('this.ruleForm[field.field]', this.ruleForm[field.field])
      },
      beforeAvatarUpload(file, field) {
        this.loading = true
        if (file.type == '') {
          Toast.fail("上传文件后缀名不正确!");
          return false
        }
        if (field.limitType) {
          let arr = field.limitType.split(",");
          console.log(arr)
          const fileType = file.name.substring(file.name.lastIndexOf("."));
          if (arr.indexOf(fileType) == -1) {
            Toast.fail("上传文件类型不正确!");
            return false
          }
        }
        if (field.maxSize && file.size / 1024 > 1024 * field.maxSize) {
          Toast.fail(`上传文件大小不能超过 ${field.maxSize}M!`);
          return false
        }

      },
      handExceed: function (file, field) {
        Toast.fail(`最多只能上传${field.maxNum}个文件！`);
      },
      handleSuccessSeal(res, file, fileList, field) {
        this.loading = false
        console.log(this.ruleForm[field.field], res, file)
        this.ruleForm[field.field].push(res.result.filePath)

        // this.uploadId = res.result.id
        // file.id = res.result.id
        // this.uploadIds.push(res.result.id)
        // this.sealList = sealList

      },
      subSealPhoto() {
        let ids = this.uploadIds.join(",")
        let params = { seal: ids, id: sessionStorage.getItem("memberId") }
        if (!ids) {
          this.$message.error("请上传盖章材料")
          return
        }
        if (this.member.memberCategory == 1) {
          saveSingleSeal(params).then((res) => {
            if (res.success) {
              this.$message.success("完成上传！")
              if (res.result && res.result.seal) {
                this.uploadIds = []
                this.uploadIds = res.result.seal.split(",")
              }
              this.dialogSeal = false
              this.member.seal = ids

              // this.reload()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          printingSeal(params).then((res) => {
            if (res.success) {
              this.$message.success("完成上传！")
              if (res.result && res.result.seal) {
                this.uploadIds = []
                this.uploadIds = res.result.seal.split(",")
              }
              this.dialogSeal = false
              this.member.seal = ids
              // this.reload()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      },
    },
    computed: {
      ...mapGetters(["searchAdd"]),
      meetingId() {
        return this.$route.query && this.$route.query.meetingId;
      },
      province() {
        return (provinceValue) =>
          this.allAddress.filter((item) => item.value === provinceValue).pop()
      },
      sheng() {
        return this.allAddress.filter((item) => item.level === 1)
      },
      shi() {
        return (sheng) => {
          let province = this.province(sheng)
          return province
            ? this.allAddress.filter((item) => item.parentId === province.id)
            : []
        }
      },
      shi1() {
        return this.allAddress.filter((item) => {
          return item.parentId === this.sheng[0].id
        })
      },
      minDate() {
        return new Date("1960")
      },
    },
    mounted() {
      if (!this.loginStatus) {
        this.getCaptchaImageFunction()
      }
      this.meetingDetailsItem = JSON.parse(getStore("meetingDetails"))
      if (this.meetingDetailsItem) {
        this.orderIsPay = this.meetingDetailsItem.orderInfo
      }
      getDictionary().then((res) => {
        if (res.success) {
          this.allDictionary = res.result
        }
      })
      getDivisionData().then((res) => {
        this.allAddress = res.result
      })
      if (this.unitDetail) {
        this.settingDetail = this.unitDetail

      }
    },
  }
</script>

<style lang="less" scoped>
  .goods {
    max-height: 420px;
    overflow: scroll;
    padding: 16px;
  }

  .inputkuang {
    padding-right: 0;
    padding-left: 0;
    padding-bottom: 70px;
  }

  .meetingFont {
    font-size: 16px;
    line-height: 32px;
    margin-top: 20px;
    padding: 0 15px;
    padding-bottom: 20px;
  }

  .attendance button {
    border-left: none;
    border-right: none;
    border-top: 5px solid #eef2f5;
    border-bottom: 5px solid #eef2f5;
    border-radius: initial;
    padding: 25px 0;
  }

  /deep/.anniu .van-radio-group>div {
    float: left;
    margin-right: 10px;
  }

  .title-box {
    font-size: 16px;
    margin-bottom: 16px;
  }

  .button-3 {
    border-radius: 28px;
    padding: 10px 20px 10px 20px;
    background-color: #1989fa;
  }

  .text-70 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: center;
    white-space: nowrap;
    line-height: 17px;
  }

  .button-6 {
    background-color: rgba(250, 173, 122, 0.14);
    border-radius: 28px;
    padding: 10px 20px 10px 20px;
  }

  .text-71 {
    overflow-wrap: break-word;
    color: #1989fa;
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  /* .inputSelect /deep/.van-checkbox {
    width: 90%;
    padding: 0.5rem 10%;
    border-bottom: 0.02667rem solid #ebedf0;
  } */

  .inputSelect {
    max-height: 50%;
  }

  .btn_left {
    width: 60px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    left: 10px;
    font-size: 14px;
    top: 10px;
    float: left;
  }

  .btn_true {
    width: 60px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    right: 10px;
    font-size: 14px;
    top: 10px;
    float: right;
  }

  .selectDiv {
    width: 100%;
    height: 0.8rem;
    position: sticky;
    padding: 0.37333rem 0 0.26667rem 0;
    top: 0;
    background: #fff;
    z-index: 99;
  }

  /deep/.van-button--default {
    border: 0 !important;
  }

  /deep/.van-cell__right-icon {
    position: absolute;
    right: 1%;
    top: 50%;
    transform: translateY(-50%);
  }

  /deep/.van-field__clear {
    position: absolute;
    right: 3%;
    top: 50%;
    transform: translateY(-50%);
  }

  /deep/.van-field__word-limit {
    position: absolute;
    right: 0;
    bottom: 0
  }

  /deep/ .van-icon {
    display: block !important;
  }

  sup {
    margin-left: 6px;
  }

  /deep/.el-button--primary {
    background-color: #00d277;
    border-color: #00d277;
  }

  /deep/.van-button--small {
    padding: 0 !important;
  }

  /deep/.van-field__control:disabled {
    background-color: #f3f3f3;
  }

  .chaImage {
    width: 90px;
    height: 30px;
    margin-left: 10px
  }

  /* .inputkuang dl.chbox .van-cell {
    background-color: #fff;
    border: #dddddd solid 0.02667rem;
    border-radius: 0.13333rem;
    padding: 0.26667rem;
    width: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
  } */
</style>